import { cloneDeep } from '@lsfe/tools';

function traverseNode(node, data) {
    if (node.children && node.children.length > 0) {
        node.children.sort((a, b) => {
            return +a.id - +b.id;
        });
    } else if (!(node.leaf === false || node.leaf === true) && !node.leaf) {
        let rawNode = data.find(i => i.id === node.id);
        node.leaf = true;
        rawNode && (rawNode.leaf = true);
    }
}

function traverseTree(node, data) {
    if (!node) {
        return;
    }
    traverseNode(node, data);
    if (node.children && node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) {
            traverseTree(node.children[i], data);
        }
    }
}
class TreeMap {
    constructor() {
        this.nodeMap = {};
    }

    getNode(id) {
        return this.nodeMap[id];
    }

    setNode(data) {
        if (data.parentId >= 0) {
            if (!this.getNode(data.parentId)) {
                this.addNode({ id: data.parentId });
            }
        }
        if (this.getNode(data.id)) {
            this.modifyNode(data);
        } else {
            this.addNode(data);
        }
        return this.getNode(data.id);
    }

    addNode(data) {
        let node = { ...data };
        // let node = new TreeNodeClass(data);
        this.getNode(data.parentId) && this.addChild(this.getNode(data.parentId), node);
        this.nodeMap[data.id] = node;
        return node;
    }

    addChild(parent, node) {
        if (!parent.children) {
            parent.children = [];
        }
        parent.children.push(node);
    }

    modifyNode(data) {
        let node = this.getNode(data.id);
        // data.parent = getNode(data.parentId);
        // node.modify(data);
        Object.assign(node, data);
    }
}

class TreeMapNew {
    constructor() {
        this.allNodeMap = {};
        this.treeNodeMap = {};
    }

    allNodeMapGen(list) {
        if (Array.isArray(list)) {
            list.forEach(node => {
                if (node && !isNaN(node.id)) {
                    this.allNodeMap[node.id] = node;
                }
            });
        }
    }

    treeNodeMapInIt() {
        let rootNode = this.allNodeMap[0];
        this.treeNodeMap[0] = rootNode;
        // console.log('this.treeNodeMap = ', this.treeNodeMap)
    }

    addTreReg2TreeMap(treeReg) {
        treeReg.forEach(node => {
            if (node && !isNaN(node.id)) {
                this.treeNodeMap[node.id] = node;
                // console.log('this.treeNodeMap = ', this.treeNodeMap)
            }
        });
    }

    addTreeNode(node, tmpTreeReg = []) {
        if (node && !this.treeNodeMap[node.id]) {
            // node存在，且当前treeMap中没有添加过这个node
            tmpTreeReg.push(node);
            let parentId = +node.parentId;
            if (!isNaN(parentId)) {
                // console.log('parentId = ', parentId)
                // 符合规范的父节点Id，通过addChild构建树片段
                let parentNode = this.allNodeMap[parentId];
                this.addChild(parentNode, node);
                if (parentId >= 0) {
                    // 不是根节点
                    if (this.treeNodeMap[parentId]) {
                        // 直到当前组成的树片段找到主树上的连接点，递归结束，
                        // 将当前树片段加到当前树节点集合
                        this.addTreReg2TreeMap(tmpTreeReg);
                    } else if (parentNode) {
                        // 如果当前递归并未找到链接主树的位置，但父节点存在
                        // 继续递归
                        this.addTreeNode(parentNode, tmpTreeReg);
                    }
                } else if (parentId === -1) {
                    // 找到了根节点，直接将当前树片段加到当前树节点集合
                    this.addTreReg2TreeMap(tmpTreeReg);
                }
            }
        }
    }

    addChild(parent, node) {
        if (parent && typeof parent === 'object') {
            if (!parent.children) {
                parent.children = [];
            }
            parent.children.push(node);
        }
    }

    getRootNode() {
        let r = this.treeNodeMap[0];
        return r;
    }

    treeGen(data) {
        let list = Array.isArray(data) ? cloneDeep(data) : [];
        if (!list.some(i => i.id === 0 || i.id === '0')) {
            list.push({ id: 0, parentId: -1 });
        }
        this.allNodeMapGen(list);
        this.treeNodeMapInIt();
        list.forEach(node => {
            if (node && !isNaN(node.id)) {
                if (!this.treeNodeMap[node.id]) {
                    this.addTreeNode(node);
                }
            }
        });
    }
}

export default function formatDataToTree(data) {
    let treeMap = new TreeMapNew();
    treeMap.treeGen(data);
    let rootNode = treeMap.getRootNode();
    traverseTree(rootNode, data);
    return rootNode.children;
}

// ========================================================================================================
/*
        格式化输入数据
        创建根节点
        将输入数据变成想要的数据
    */
// export default function formatDataToTree(data) {
//     // let treeMap = new TreeMap();
//     let treeMap = new TreeMapNew();
//     // treeNodeMapViewData = [];

//     let list = Array.isArray(data) ? data : [];
//     let rootNode = treeMap.addNode({ id: 0, parentId: -1 });
//     // rootNode.node.open = true;
//     // treeNodeMapViewData.push(rootNode);
//     list.forEach(item => {
//         treeMap.setNode(item);
//         // treeMap.addNode(item);
//     });
//     // debugger
//     traverseTree(rootNode, data)

//     return rootNode.children;
// }
